/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamRefSchema = z.object({
  teamId: z.int(),
  teamName: z.string().nullish(),
});
